module.exports = __webpack_public_path__ + "static/img/Company-Program_Simplify_wires.85fb03e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/Company-Program_Simplify_wires.jpg
// module id = Dp+I
// module chunks = 0